// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/TestTiemposText-Medium-BF66457a508489a.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "TiemposText";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  background-color: white;
  color: rgb(0, 0, 0);
  font-family: "TiemposText", sans-serif;
  background-color: #eee2df;
}

.logo {
  font-size: 1.5rem;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 1rem;
}

.nav-links a {
  color: black;
  font-family: "system-ui", sans-serif;
  text-decoration: none;
}

.name {
  display: flex; /* Aligns items in a row */
  align-items: center; /* Vertically center the icon and text */
  gap: 8px; /* Space between the icon and the name */
}

.icon {
  flex: 1 1;
  width: 2.3rem;
}

.nav-option {
  cursor: pointer;
  transition: font-size 0.2s ease, font-weight 0.2s ease; /* Smooth animation for hover effects */
}

.nav-option:hover {
  font-weight: bold;
  font-size: 1.1rem;
}

.nav-option:active {
  font-weight: regular;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa,EAAE,0BAA0B;EACzC,mBAAmB,EAAE,wCAAwC;EAC7D,QAAQ,EAAE,wCAAwC;AACpD;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sDAAsD,EAAE,uCAAuC;AACjG;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["@font-face {\n  font-family: \"TiemposText\";\n  src: url(\"../assets/TestTiemposText-Medium-BF66457a508489a.otf\")\n    format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  background-color: white;\n  color: rgb(0, 0, 0);\n  font-family: \"TiemposText\", sans-serif;\n  background-color: #eee2df;\n}\n\n.logo {\n  font-size: 1.5rem;\n}\n\n.nav-links {\n  list-style: none;\n  display: flex;\n  gap: 1rem;\n}\n\n.nav-links a {\n  color: black;\n  font-family: \"system-ui\", sans-serif;\n  text-decoration: none;\n}\n\n.name {\n  display: flex; /* Aligns items in a row */\n  align-items: center; /* Vertically center the icon and text */\n  gap: 8px; /* Space between the icon and the name */\n}\n\n.icon {\n  flex: 1;\n  width: 2.3rem;\n}\n\n.nav-option {\n  cursor: pointer;\n  transition: font-size 0.2s ease, font-weight 0.2s ease; /* Smooth animation for hover effects */\n}\n\n.nav-option:hover {\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.nav-option:active {\n  font-weight: regular;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
